var _g, _path, _g2, _path2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_428_36031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3707 7.3076H11.0876V6.46239C11.0876 6.23823 10.9986 6.02325 10.84 5.86474C10.6815 5.70624 10.4666 5.61719 10.2424 5.61719H6.86156C6.6374 5.61719 6.42242 5.70624 6.26391 5.86474C6.1054 6.02325 6.01635 6.23823 6.01635 6.46239V7.3076H5.72898C5.69312 7.3076 5.65872 7.32185 5.63336 7.34721C5.608 7.37257 5.59375 7.40697 5.59375 7.44284V8.44018C5.59375 8.51498 5.65418 8.57541 5.72898 8.57541H6.01635V11.111C6.01635 11.3435 6.01635 11.5336 6.43896 11.5336V12.1675C6.43896 12.2236 6.46122 12.2773 6.50085 12.317C6.54047 12.3566 6.59422 12.3788 6.65026 12.3788H7.49547C7.55151 12.3788 7.60525 12.3566 7.64488 12.317C7.68451 12.2773 7.70677 12.2236 7.70677 12.1675V11.5336H9.39719V12.1675C9.39719 12.2236 9.41945 12.2773 9.45907 12.317C9.4987 12.3566 9.55245 12.3788 9.60849 12.3788H10.4537C10.5097 12.3788 10.5635 12.3566 10.6031 12.317C10.6427 12.2773 10.665 12.2236 10.665 12.1675V11.5336C11.0876 11.5336 11.0876 11.3435 11.0876 11.111V8.57541H11.3707C11.4077 8.57541 11.4432 8.56072 11.4694 8.53457C11.4955 8.50841 11.5102 8.47294 11.5102 8.43595C11.5102 8.39897 11.4955 8.3635 11.4694 8.33734C11.4432 8.31119 11.4077 8.29649 11.3707 8.29649C11.3338 8.29649 11.2983 8.31119 11.2721 8.33734C11.246 8.3635 11.2313 8.39897 11.2313 8.43595C11.2313 8.47294 11.246 8.50841 11.2721 8.53457C11.2983 8.56072 11.3338 8.57541 11.3707 8.57541C11.4077 8.57541 11.4432 8.56072 11.4694 8.53457C11.4955 8.50841 11.5102 8.47294 11.5102 8.43595V7.44706C11.5102 7.41007 11.4955 7.3746 11.4694 7.34845C11.4432 7.3223 11.4077 7.3076 11.3707 7.3076ZM7.70677 6.03979H9.39719V6.46239H7.70677V6.03979ZM6.86156 10.6884C6.74948 10.6884 6.64199 10.6439 6.56274 10.5647C6.48348 10.4854 6.43896 10.3779 6.43896 10.2658C6.43896 10.1537 6.48348 10.0463 6.56274 9.967C6.64199 9.88775 6.74948 9.84322 6.86156 9.84322C6.97364 9.84322 7.08113 9.88775 7.16039 9.967C7.23964 10.0463 7.28417 10.1537 7.28417 10.2658C7.28417 10.3779 7.23964 10.4854 7.16039 10.5647C7.08113 10.6439 6.97364 10.6884 6.86156 10.6884ZM6.43896 8.99802V6.885H10.665V8.99802H6.43896ZM10.2424 10.6884C10.1303 10.6884 10.0228 10.6439 9.94357 10.5647C9.86431 10.4854 9.81979 10.3779 9.81979 10.2658C9.81979 10.1537 9.86431 10.0463 9.94357 9.967C10.0228 9.88775 10.1303 9.84322 10.2424 9.84322C10.3545 9.84322 10.462 9.88775 10.5412 9.967C10.6205 10.0463 10.665 10.1537 10.665 10.2658C10.665 10.3779 10.6205 10.4854 10.5412 10.5647C10.462 10.6439 10.3545 10.6884 10.2424 10.6884Z",
    fill: "#00CAF6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_36031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53829 8.3552L1.43586 8.41317L0.0478387 5.42077L11.7344 0L14.6355 6.25438L5.6313 10.4309L4.69345 8.40905L3.53829 8.3552Z",
    fill: "#00CAF6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_36031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17063 11.5108C2.50735 10.0808 2.43928 8.4459 2.9814 6.96574C3.52353 5.48558 4.63144 4.28141 6.06141 3.61812C7.49138 2.95483 9.12628 2.88676 10.6064 3.42889C12.0866 3.97101 13.2908 5.07892 13.9541 6.50889",
    stroke: "#00CAF6",
    strokeWidth: 0.95096
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16333 8.39991L2.68914 10.9854L4.16537 8.37128L1.16333 8.39991Z",
    fill: "#00CAF6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_36031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 16,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5789 9.6448L15.6813 9.58683L17.0693 12.5792L5.38281 18L2.48173 11.7456L11.4859 7.56906L12.4237 9.59095L13.5789 9.6448Z",
    fill: "#00CAF6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_36031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9466 6.48924C14.6098 7.91921 14.6779 9.5541 14.1358 11.0343C13.5937 12.5144 12.4857 13.7186 11.0558 14.3819C9.6258 15.0452 7.99091 15.1132 6.51075 14.5711C5.03059 14.029 3.82642 12.9211 3.16313 11.4911",
    stroke: "#00CAF6",
    strokeWidth: 0.95096
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.946 9.60009L14.4202 7.01457L12.944 9.62872L15.946 9.60009Z",
    fill: "#00CAF6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_428_36031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.76166,
    height: 6.76166,
    fill: "white",
    transform: "translate(5.17188 5.61719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.79bdf2e6d7a83a1425dda48a1fd99d14.svg";
export { ForwardRef as ReactComponent };